document.addEventListener('DOMContentLoaded', function() {

    //reorder section with technical information on mobile
    if ('IntersectionObserver' in window) {
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.1
        };
  
        let originalParent = null;
        let originalNextSibling = null;
        const target = document.getElementById("spectacle-aside-general");

        const mainContent = document.getElementById('spectacle-inner');
        const description = document.getElementById('spectacle-description');
  
        function moveSection(isMobile) {
          if (isMobile) {
            // Store original position
            if (!originalParent) {
              originalParent = target.parentNode;
              originalNextSibling = target.nextElementSibling;
            }
            // Insert before description
            mainContent.insertBefore(target, description);
          } else if (originalParent) {
            // Return to original position
            originalParent.insertBefore(target, originalNextSibling);
          }
        }
  
        const handleIntersection = (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const section = entry.target;
              
              if (section === target) {
                moveSection(window.matchMedia('(max-width: 768px)').matches);
              }
              
              observer.unobserve(section);
            }
          });
        };
  
        const observer = new IntersectionObserver(handleIntersection, options);
  
        // Observe target
        if(target){
            observer.observe(target);
        }
  
        // Handle resize events
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        
        // Add the event listener
        mediaQuery.addEventListener('change', (e) => {
            moveSection(e.matches);
        });
  
        // Initial check
        if (mediaQuery.matches) {
          moveSection(true);
        }
      } 
});